import Vue from 'vue'
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth'
import 'firebase/firestore';
import { createApp } from './app';
import axios from 'axios';
import querystring from 'querystring';
import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import LngDetector from 'i18next-browser-languagedetector';
import pickBy from 'lodash.pickby';
import negate from 'lodash.negate';
import isEmpty from '../is-empty';

(async () => {
  try {
    firebase.app();
  } catch (err) {
    firebase.initializeApp(require('../firebase-config.json'));
  }
  const { projectId } = firebase.app().options;
  const urlParams = new URLSearchParams(window.location.search);
  const access_token = urlParams.get('access_token');
  const did = urlParams.get('did');
  const dn = urlParams.get('dn');
  let firebaseCustomToken = urlParams.get('fct');
  const videoSource = urlParams.get('source');
  const regionCode = urlParams.get('regionCode');
  const eventId = urlParams.get('eventId');
  const lng = urlParams.get('lng') || 'en';
  const layout = urlParams.get('layout');
  await i18next
    .use(LngDetector)
    .use(XHR)
    .init({
      fallbackLng: 'en',
    });

  if (firebaseCustomToken) {
    await firebase.auth().signInWithCustomToken(firebaseCustomToken);
  } else if (access_token) {
    const { data: { customToken } } = await axios.get(`https://us-central1-${projectId}.cloudfunctions.net/exchangeToken`, {
      params: {
        token: access_token,
        baseUrl: process.env.VUE_APP_EXCHANGE_TOKEN_BASE_URL,
      },
    });
    firebaseCustomToken = customToken;
    await firebase.auth().signInWithCustomToken(customToken);
  }
  const controllerBaseUrl = process.env.VUE_APP_CONTROLLER_BASE_URL || `https://ezchannel-recommended.firebaseapp.com`;
  const controllerQuery = querystring.stringify(pickBy({
    did,
    dn,
    access_token,
    fct: firebaseCustomToken,
    source: videoSource,
    regionCode,
    lng,
  }, negate(isEmpty)));
  let controllerUrl = `${controllerBaseUrl}/?${controllerQuery}`;
  const { app, store } = await createApp({
    database: firebase.database(),
    uid: firebase.auth().currentUser.uid,
    controllerUrl,
    videoSource,
    regionCode,
    googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
    i18next,
    maxResults: 8,
    firestore: firebase.firestore(),
    eventId,
    layout,
    access_token,
    projectId,
  });

  Vue.config.productionTip = false

  if (window.__INITIAL_STATE__) {
    // We initialize the store state with the data injected from the server
    store.replaceState(window.__INITIAL_STATE__)
  }

  app.$mount('#app');
})();
